import React from "react";
import Layout from "../../components/Layout";
import PageIntro from "../../components/PageIntro";
import ImageBanner from "../../components/ImageBanner";
import FinalCtaPanel from "../../components/FinalCtaPanel";
import "../../styles/brand.css";
import FoodSafetyStandards from "./FoodSafetyStandards";
import FoodSafetyProcess from "./FoodSafetyProcess";
import FoodSafetyIndustries from "./FoodSafetyIndustries";
import FoodSafetyWhyChoose from "./FoodSafetyWhyChoose";
import {
  finalCtaContent,
  foodSafetySeo,
  heroContent,
  servicesContent,
} from "./foodSafetyContent";

const SITE_URL = "https://mbasolutions.co";
const CANONICAL = `${SITE_URL}${foodSafetySeo.slug}`;

const buildJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "Service",
    name: heroContent.h1,
    description: foodSafetySeo.description,
    url: CANONICAL,
    serviceType: "Food safety certification consultancy",
    provider: { "@type": "Organization", name: "MBA Solutions", url: SITE_URL },
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: servicesContent.title,
      itemListElement: servicesContent.services.map((service) => ({
        "@type": "Offer",
        itemOffered: { "@type": "Service", name: service.title },
      })),
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: `${SITE_URL}/services`,
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "Food Safety Services",
        item: CANONICAL,
      },
    ],
  },
];

const FoodSafetyServices = () => (
  <Layout
    title={foodSafetySeo.title}
    description={foodSafetySeo.description}
    keywords="food safety consultancy, HACCP certification, Halal certification, FSSC 22000, BRCGS Food Safety, GMP GHP implementation, food safety management system, MBA Solutions"
    canonical={CANONICAL}
    jsonLd={buildJsonLd()}
  >
    <main className="food-safety-page brand-page bg-white">
      {/* the supplied banner, shown whole — never cropped */}
      <ImageBanner
        src="/assets/banners/Our-Food-Safety-Services.jpeg"
        alt="Our Food Safety Services — MBA Solutions"
        width={1757}
        height={592}
        whole
      />
      <PageIntro
        id="food-safety-heading"
        title={heroContent.h1}
        subtitle={heroContent.subtitle}
        paragraphs={heroContent.paragraphs}
      />
      <FoodSafetyStandards />
      <FoodSafetyProcess />
      <FoodSafetyIndustries />
      <FoodSafetyWhyChoose />
      <FinalCtaPanel
        id="food-safety-final-cta-heading"
        title={finalCtaContent.title}
        paragraph={finalCtaContent.paragraph}
        cta={finalCtaContent.cta}
        image="/assets/cta/certification-journey.webp"
      />
    </main>
  </Layout>
);

export default FoodSafetyServices;
